import styled from '@emotion/styled';
import { Stack, TextField, Typography } from '@mui/material';

type Props = {
  sx?: any;
  inputSx?: any;
  label?: string;
  error?: boolean;
  disabled?: boolean;
  placeholder?: string;
  helperText?: string;
  value: number | string;
  type?: string;
  rows?: number;
  minRows?: number;
  onChange: (e: any) => void;
}

function Input(props: Props) {

  return (
    <Stack mt={2} sx={props.sx}>
      {props.label && <StyledTypography sx={{fontSize: 14}} >{props.label}</StyledTypography>}
      <StyledInput
        error={props.error}
        variant="outlined"
        type={props.type}
        multiline
        rows={props.rows}
        minRows={props.minRows}
        helperText={props.helperText}
        disabled={props.disabled}
        placeholder={props.placeholder}
        sx={props.inputSx} value={props.value}
        onChange={(e) => props.onChange(e.target.value)} />
    </Stack>
  );
}

const StyledTypography = styled(Typography)({
  fontWeight: 700,
  fontSize: 14,
  color: "#0F172A"
});

const StyledInput = styled(TextField)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  marginTop: 4,
  backgroundColor: "white",
}));

export default Input;